'use client';

// Third Party
import Image from 'next/image';

// Utils
import { imagekitLoader } from '@utils/imagekit-loader';
import { GRAY_PIXEL_DATA_URL } from '@utils/constants';

// UI
import { Alphatar } from '@components/alphatar';

export type IAvatarProps = {
  firstName?: string;
  lastName?: string;
  avatarUrl?: string;
  linkTo?: string;
  sizes?: string;
  shape: 'circle' | 'square';
};

export const Avatar: React.FC<IAvatarProps> = ({
  firstName,
  lastName,
  avatarUrl,
  linkTo,
  sizes,
  shape,
}) => {
  if (linkTo) {
    if (avatarUrl) {
      return (
        <div className="relative overflow-hidden h-full hover:opacity-70 aspect-1 bg-white rounded-full">
          <a href={linkTo} target="_blank" rel="noreferrer">
            <Image
              layout="fill"
              src={avatarUrl}
              alt="user avatar"
              placeholder="blur"
              className="object-center object-cover"
              loader={imagekitLoader}
              blurDataURL={GRAY_PIXEL_DATA_URL}
              sizes={sizes}
            />
          </a>
        </div>
      );
    } else {
      return (
        <a
          className="hover:opacity-70 w-full h-full"
          href={linkTo}
          target="_blank"
          rel="noreferrer"
        >
          <Alphatar firstName={firstName} lastName={lastName} shape={shape} />
        </a>
      );
    }
  }

  if (avatarUrl) {
    return (
      <div className="relative overflow-hidden h-full aspect-1 bg-white rounded-full">
        <Image
          layout="fill"
          src={avatarUrl}
          alt="user avatar"
          placeholder="blur"
          className="object-center object-cover"
          loader={imagekitLoader}
          blurDataURL={GRAY_PIXEL_DATA_URL}
          sizes={sizes}
        />
      </div>
    );
  } else {
    return (
      <div className="w-full h-full">
        <Alphatar firstName={firstName} lastName={lastName} shape={shape} />
      </div>
    );
  }
};
